export const ACCOUNTDELETED = '/account/deleted';
export const ACCOUNTDELETEDISCLAIMER = '/account/delete-disclaimer';
export const HOME = '/';
export const LOGIN = '/account/login';
export const SIGNUP = '/account/signup';
